import { classNames } from "../../util/helpers";
import { CellWrapperType } from "../types";
import SortAscIcon from "../../assets/images/table-sort-ascending.svg";
import SortDescIcon from "../../assets/images/table-sort-descending.svg";
import SortableICon from "../../assets/images/table-sort-is-sortable.svg";
import { useTableContext } from "./TableContext";

/**
 * This is a custom wrapper component of table cell or header cell
 * @param CellWrapperType
 * @returns JSX
 */
export const CellWrapper = ({ enable = true, children, style, sortable, accessor, ariaDescription }: CellWrapperType) => {

    const { onSortFunction, sortBy, sortOrder } = useTableContext();
    const wcn = classNames('ted-ui-cell-wrapper');

    const onClickColumn = (e: React.MouseEvent) => {
        e.preventDefault();
        let asorder = sortOrder;
        if (accessor !== sortBy || !sortBy) {
            asorder = 'ascending';
        } else {
            if (asorder === 'none') {
                asorder = 'ascending';
            } else if (asorder === 'ascending') {
                asorder = 'descending';
            } else if (asorder === 'descending') {
                asorder = 'ascending';
            } else {
                asorder = 'none';
            }
        }

        onSortFunction && onSortFunction(accessor as string, asorder);
    }

    const getSortIcon = () => {
        const aria: React.AriaAttributes = {
            "aria-hidden": true
        };

        if (accessor === sortBy) {
            if (sortOrder === 'ascending') {
                return <SortAscIcon data-testid="assending-icon" {...aria} />
            } else if (sortOrder === "descending") {
                return <SortDescIcon data-testid="descending-icon" {...aria} />
            }
        }
        return <SortableICon data-testid="nosort-icon" {...aria} />;
    }

    if (sortable) {
        return <button type='button' data-testid={"sortButton-" + accessor}
            aria-description={ariaDescription} className={wcn} style={style as any}
            onClick={onClickColumn}>
            {children} {getSortIcon()}
        </button>
    }

    if (enable) {
        return <div className={wcn} style={style as any}>{children}</div>
    }

    return <>{children}</>;
}
